import Clickable from "@components/clickable";
import styled from "styled-components";

export const StyledEditableAmount = styled(Clickable) <{
    isRowSelected?: boolean;
}>`
    // opacity: ${props => props.isRowSelected ? "1" : "0.5"};
    // cursor: ${props => props.isRowSelected ? "pointer" : "default"};
`;

export const AmountWrapper = styled.span`
    margin-left: 2px;
    margin-top: 2px;
    font-weight: bold;
`;

/* ---- EditableAmountDialog styles ---- */

/* ---- /EditableAmountDialog styles ---- */